module.exports = __webpack_public_path__ + "static/media/sortUp.9058353c.svg";